// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__-IAdC","label":"SetPasswdForm_label__1btFK"};